export function formatIncludeSharedAccommodation(
    includeSharedAccommodation: string | string[]
) {
    if (includeSharedAccommodation === 'true') {
        return 'Include shared accommodation';
    }

    return '';
}
